// Função para remover acentos de uma string
export const removeAccents = (str: string): string => {
  return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
};

// Função para normalizar texto para busca (remove acentos e converte para minúsculas)
export const normalizeForSearch = (text: string): string => {
  return removeAccents(text.toLowerCase());
};

// Função para verificar se uma string contém outra, ignorando acentos
export const containsIgnoreAccents = (text: string, searchTerm: string): boolean => {
  const normalizedText = normalizeForSearch(text);
  const normalizedSearchTerm = normalizeForSearch(searchTerm);
  return normalizedText.includes(normalizedSearchTerm);
};

// Função para verificar se alguma palavra do texto contém o termo de busca
export const containsWordIgnoreAccents = (text: string, searchTerm: string): boolean => {
  const normalizedText = normalizeForSearch(text);
  const normalizedSearchTerm = normalizeForSearch(searchTerm.trim());
  
  // Se o termo de busca contém espaços, verificar se todas as palavras estão presentes
  if (normalizedSearchTerm.includes(' ')) {
    const searchWords = normalizedSearchTerm.split(/\s+/);
    return searchWords.every(searchWord => 
      normalizedText.split(/\s+/).some(textWord => textWord.includes(searchWord))
    );
  }
  
  // Para uma única palavra, verificar se alguma palavra do texto contém o termo
  const words = normalizedText.split(/\s+/);
  return words.some(word => word.includes(normalizedSearchTerm));
};

